// let type = "DEV";

let type = "PRD";

let HOST_URL = "";

let baseURL = "";

let baseUrlRate = "";

let basename = "";

let DOC_OCR_URL = "";

if (type === "PRD") {
  HOST_URL = "https://dashboard.mts-logistics.com/MTSconnectAPImerge/";

  baseURL = "https://dashboard.mts-logistics.com/orderManagementApi/";

  baseUrlRate = "https://dashboard.mts-logistics.com/MTSConnectRateAPI/"; // DOC_OCR_URL = "https://dashboard.mts-logistics.com/MTSOrderOcrOcelotAPI";

  DOC_OCR_URL = "https://dev.sflhub.com/MtsOcrTest";

  basename = "mts";
} else if (type === "DEV") {
  HOST_URL = "https://dev.sflhub.com/MTSConnectAPI/";

  baseURL = "https://dashboard.mts-logistics.com/orderManagementApiDEV/";

  baseUrlRate = "https://dev.sflhub.com/MTSConnectRateAPI/";

  DOC_OCR_URL = "https://dev.sflhub.com/MtsOcrTest";

  basename = "mtswithpo";
}

export { HOST_URL, baseURL, baseUrlRate, basename, DOC_OCR_URL };

// export const DOC_OCR_URL = "https://dev.sflhub.com/MTSOrderOcrOcelotAPI";

// --mtslive--

// export const HOST_URL =

//   "https://dashboard.mts-logistics.com/MTSconnectAPImerge/";

// export const baseURL = "https://dashboard.mts-logistics.com/orderManagementApi";

// export const basename = "mts";

// export const DOC_OCR_URL =

//   "https://dashboard.mts-logistics.com/MTSOrderOcrOcelotAPI";

// --mtslive--

// ---------------------------

//-- mtsdev--

// export const HOST_URL = "https://dev.sflhub.com/MTSConnectAPI/";

// export const baseURL =

//   "https://dashboard.mts-logistics.com/orderManagementApiDEV/";

// export const baseUrlRate = "https://dev.sflhub.com/MTSConnectRateAPI/";

// export const basename = "mtswithpo";

// export const basename = "mtswithpo";

//-- mtsdev--

export const LOCAL_STORAGE_KEY = {
  user_token: "UserDataLogin",
};
